import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ViolationDetailResponse } from '@/types/apps/violation-detail.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ViolationDetailTaskCheckGraphQLServiceInterface {}

type ViolationDetailTaskCheckGraphQLListResponse =
    GqlListResponse<ViolationDetailResponse>;

export class ViolationDetailTaskCheckGraphQLService
    extends BaseService
    implements ViolationDetailTaskCheckGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'violationDetailTaskCheck';
    }

    public getFields(): Record<string, any> {
        return {
            additionalNotes: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            detailDescription: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            onSiteConfirmerName: true,
            predictivedReason: true,
            proposals: true,
            recommendedActions: true,
            recordedAt: true,
            severityLevelId: true,
            solution: true,
            taskCheckId: true,
            violationDetailId: true,
            violationDetailName: true,
            violationDetailTaskCheckStatus: true,
            violationTypeId: true,
            taskCheck: {
                assigneeName: true,
                assigneeId: true,
                ticket: {
                    assigneeName: true,
                    customerId: true,
                    name: true,
                    id: true,
                    customer: {
                        name: true,
                    },
                },
                device: {
                    name: true,
                    id: true,
                },
            },
            severityLevel: {
                id: true,
                name: true,
                color: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<ViolationDetailTaskCheckGraphQLListResponse> {
        return this.fetchGqlList<ViolationDetailTaskCheckGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('violationDetailTaskCheck', {
            userId: this.getQueryById(),
        });
    }
}
